import { render } from "./VUEAppContentGestioneSiti.vue?vue&type=template&id=409578de"
import script from "./VUEAppContentGestioneSiti.vue?vue&type=script&lang=js"
export * from "./VUEAppContentGestioneSiti.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__